import React, { FC, useEffect } from 'react';
import PatternCard from 'components/organisms/PatternCard';
import useBeers from 'hooks/useBeers';
import { Container, Grid, makeStyles } from '@material-ui/core';
import lodash from 'lodash';

const useStyles = makeStyles(() => ({
  navSpace: {
    marginTop: 32,
  },
}));

const InfiniteScroll: FC = () => {
  const classes = useStyles();
  const { beers, setPageNumber } = useBeers();

  const handleScroll = lodash.throttle(() => {
    if (
      window.innerHeight + document.documentElement.scrollTop !==
      document.documentElement.offsetHeight
    ) {
      return;
    }
    setPageNumber(prev => prev + 1);
  }, 200);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Container maxWidth="md" className={classes.navSpace} id="list">
        <Grid container spacing={4}>
          {beers.map((beer: any) => (
            <PatternCard
              key={beer.id}
              id={beer.id}
              title={beer.title}
              imageSrc={beer.imageSrc}
              isLink={false}
            />
          ))}
        </Grid>
      </Container>
    </>
  );
};

export default InfiniteScroll;
